import React, { PureComponent } from "react";
import license from "../../../images/license.svg";
import { BackArrowIcon } from "../../../components/icons";
import _ from "lodash";
import Dropzone from 'react-dropzone';
import Camera, { FACING_MODES, IMAGE_TYPES } from "react-html5-camera-photo";
import "react-html5-camera-photo/build/css/index.css";
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;
class NewDriver extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      getShadowRoot: false,
      intervalId: "",
      driverData: [],
      webCam: false,
      spinning: false
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.getShadowRoot !== this.state.getShadowRoot) {
      this.setIntervalFunction();
    }
  }

  componentDidMount() {
    const { user } = this.props;
    if (_.get(user, "company.microblinkEnabled", false)) {
      this.initializeMicroblink();
    }
  }

  initializeMicroblink() {
    window.Microblink.SDK.SetRecognizers(["USDL", "BLINK_ID", "MRTD"]);
    window.Microblink.SDK.SetUserId(process.env.REACT_APP_MICROBLINK_USERID);
    window.Microblink.SDK.SetAuthorization(process.env.REACT_APP_MICROBLINK_TOKEN);
    window.Microblink.SDK.RegisterListener({
      onScanSuccess: ({ result, sourceBlob }) => {
        const data = result.data.filter(({ recognizer }) => recognizer === "BLINK_ID")[0];
        if (!data.result) {
          this.setState({ loading: false });
          return;
        }
        const state = {
          firstName: _.get(data, "result.firstName", ""),
          lastName: _.get(data, "result.lastName", ""),
          licenseNumber: _.get(data, "result.documentNumber", ""),
          formdata: sourceBlob
        };
        this.props.setInitialState({ state });

      },
      onScanProgress: error => {
        console.error("Error from Microblink API is", error);
        this.setState({ loading: false });
        // Display generic alert
        if (error.summary) {
          alert(error.summary);
        }
      }
    });
    // this.setIntervalFunction();
  }

  setIntervalFunction() {
    let mb = document.querySelector("microblink-ui-web");
    if (!this.state.getShadowRoot) {
      const intervalId = setInterval(() => {
        if (mb.shadowRoot) {
          mb.setLocalization({
            labels: {
              chooseInputMethod: "Select how to add driver license"
            }
          });
          mb.shadowRoot.getElementById("file").addEventListener("click", function () {
            this.value = "";
          });
          mb.shadowRoot.getElementById("file").addEventListener("touchstart", function () {
            this.value = "";
          });
          mb.shadowRoot
            .getElementById("cancelBtnLocalCamera")
            .addEventListener("click", this.cancelBtnLocalCameraClick.bind(this));
          mb.shadowRoot.getElementById("cameraLocalBtn").addEventListener("click", this.fileChosen.bind(this));
          mb.shadowRoot.getElementById("file").addEventListener("change", this.fileChosen.bind(this));
          mb.shadowRoot
            .querySelector(".error-container")
            .addEventListener("click", this.cancelBtnLocalCameraClick.bind(this));
          mb.shadowRoot.getElementById("cardPlacer").style.display = "none";
          this.setState({ getShadowRoot: true });
        }
      }, 50);
      this.setState({ intervalId });
    }
    if (this.state.getShadowRoot) {
      clearInterval(this.state.intervalId);
    }
  }

  fileChosen() {
    this.setState({ loading: true });
  }

  cancelBtnLocalCameraClick() {
    this.setState({ loading: false });
  }


  onDrop = acceptedFiles => {
    const imageFiles = acceptedFiles.filter(file => file.type.startsWith('image/'));
    if (imageFiles.length > 0) {
    if (acceptedFiles.length > 0) {
      var formdata = new FormData();
      formdata.append("file", acceptedFiles[0]);
      this.getBase64(acceptedFiles[0], async (result) => {
        const blob = this.dataURItoBlob(await this.compressImage(result, 0.7))
        this.getDriverDetails(formdata, blob)
      });
    }
  } else {
    alert("Please upload image file only");
  }
  }

  // textract
  getDriverDetails = async (payloadData, blob) => {
    this.setState({ spinning: true })
    const { driverDetails } = this.props;
    try {
      const {
        value: { status, data }
      } = await driverDetails(payloadData);
      if (status) {
        this.setState({ driverData: data, spinning: false })
        let state = {
          firstName: "",
          lastName: "",
          licenseNumber: "",
          formdata: blob
        };
        data.length > 0 && data.map(function (item, index) {
          if (item.key === 'FIRST_NAME') {
            state.firstName = item.value
          }
          else if (item.key === 'LAST_NAME') {
            state.lastName = item.value
          }
          else if (item.key === 'DOCUMENT_NUMBER') {
            state.licenseNumber = item.value
          }
          else if (item.key === 'STATE_NAME') {
            var splitStr = item.value.toLowerCase().split(' ');
            for (var i = 0; i < splitStr.length; i++) {
                splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);     
            }
            state.state = splitStr.join(' ')
          }
          return item;
        })
        this.props.setInitialState({ state });
      } else {
        this.setState({ spinning: false })
      }
    } catch (error) {
      this.setState({ spinning: false })
      alert("File is too large");
    }
 
  };

  onTakePhoto = async (dataUri) => {
   const compressedImage= await this.compressImage(dataUri, 0.7)
    const blob = this.dataURItoBlob(compressedImage);
    const formdata = new FormData();
    formdata.append("file", blob);
    await this.getDriverDetails(formdata, blob)
  };

  getBase64(file, cb) {
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      cb(reader.result)
    };
    reader.onerror = function (error) {
      console.log('Error: ', error);
    };
  }
  compressImage = async (imageUrl, quality) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = "anonymous"; 
      img.src = imageUrl;
      img.onload = () => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        canvas.width = img.width;
        canvas.height = img.height;
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
        const compressedImageUrl = canvas.toDataURL("image/jpeg", quality);
        resolve(compressedImageUrl);
      };
  
      img.onerror = (error) => {
        reject(error);
      };
    });
  };
  dataURItoBlob = dataURI => {
    var binary = atob(dataURI.split(",")[1]);
    var array = [];
    for (var i = 0; i < binary.length; i++) {
      array.push(binary.charCodeAt(i));
    }
    return new Blob([new Uint8Array(array)], { type: "image/jpeg" });
  };
  render() {
    const { loading } = this.state;

    return (
      <div>
        <div className="newdriver__wrapper">
          <div className="header__container">
            <div className="container">
              <div className="row">
                <div className="col-md-12">
                  <div className="head-section-header">
                    {!this.props.fromPopUp && (<div className="mr-auto">
                      {/*<div className="btn btn-link btn-back p-r-0" onClick={() => this.props.onClose()}>
                        <CloseIcon />
                      </div>*/}
                      <button className="btn btn-link btn-back" onClick={() => this.props.onClose()}>
                        <BackArrowIcon /> Back
                      </button>
                    </div>)}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Spin indicator={antIcon} spinning={this.state.spinning}>
            <div className="newdriver-container">
              <div className="container">
                <div className="row">
                  <div className="col-md-12">
                    <div className="newdriver__inner">
                      {/* {_.get(user, "company.microblinkEnabled", false) && ( */}
                        <div className="aws__section">
                          <div className="aws__inner">
                            <h3>Select how to add driver license</h3>
                            <ul className="aws__list">
                              <li className="items">
                                <Dropzone
                                  onDrop={this.onDrop}
                                  accept="image/png,image/jpeg,image/gif,image/jpg"

                                >
                                  {({ getRootProps, getInputProps }) => (

                                    <div className="items-inner" {...getRootProps()}>
                                      <div className="circle">
                                        <input {...getInputProps()} />
                                        <svg width="100%" viewBox="0 0 70 70" fill="none"
                                          stroke="black" xmlns="http://www.w3.org/2000/svg">
                                          <path d="M34.3388 13.3654V42.6923" strokeLinecap="round"
                                            strokeLinejoin="round"></path>
                                          <path d="M43.1777 18.8388L35.7531 11.4142C34.972 10.6332 33.7057 10.6332 32.9246 11.4142L25.5 18.8388" strokeLinecap="round" strokeLinejoin="round"></path> <path d="M38.2404 59.9999H49.0577" strokeLinecap="round" strokeLinejoin="round"></path> <path d="M13 52.3077V57C13 58.6568 14.3431 60 16 60H35.1154" strokeLinecap="round" strokeLinejoin="round"></path> <path d="M56.2692 52.3076V56.9999C56.2692 58.6568 54.9261 59.9999 53.2692 59.9999H49.5385" strokeLinecap="round" strokeLinejoin="round">
                                          </path>
                                          <path d="M18.7692 55.673H49.5385" strokeLinecap="round" strokeLinejoin="round"></path>
                                        </svg>
                                      </div>
                                    </div>
                                  )}
                                </Dropzone>
                                <p>Upload image</p>
                              </li>
                              <li className="items">
                                <div className="items-inner" onClick={() => this.setState({ webCam: true })}>
                                  <div className="circle">

                                    <svg width="100%" viewBox="0 0 70 70" fill="none" stroke="black" xmlns="http://www.w3.org/2000/svg"> <path d="M35.7171 14.7725C36.4106 14.7725 36.9728 14.2104 36.9728 13.5169C36.9728 12.8234 36.4106 12.2612 35.7171 12.2612C35.0237 12.2612 34.4615 12.8234 34.4615 13.5169C34.4615 14.2104 35.0237 14.7725 35.7171 14.7725Z" strokeLinecap="round" strokeLinejoin="round"></path> <path d="M12.9204 33.9312V16.3388C12.9204 12.843 15.7739 10 19.2829 10H48.013" strokeLinecap="round" strokeLinejoin="round"></path> <path d="M13.2887 46.0429H58.3318C58.5345 46.0429 58.6977 45.8797 58.6977 45.6744V16.4415C58.6977 12.9457 55.8442 10.1027 52.3352 10.1027" strokeLinecap="round" strokeLinejoin="round"></path> <path d="M10.1772 50.0759H18.5983C18.801 50.0759 18.9668 50.2391 18.9668 50.4445V51.4948" strokeLinecap="round" strokeLinejoin="round"></path> <path d="M21.0305 50.0758H26.3822" strokeLinecap="round" strokeLinejoin="round"></path> <path d="M28.8171 50.0758H34.1688C34.3715 50.0758 34.5373 50.239 34.5373 50.4443V51.4947" strokeLinecap="round" strokeLinejoin="round"></path> <path d="M36.6039 50.0758H41.9556" strokeLinecap="round" strokeLinejoin="round"></path> <path d="M44.3907 50.0758H49.7423" strokeLinecap="round" strokeLinejoin="round"></path> <path d="M8.01323 54.4904H18.5981C18.8008 54.4904 18.9667 54.6536 18.9667 54.8589V55.9092" strokeLinecap="round" strokeLinejoin="round"></path> <path d="M21.0303 54.4904H26.382" strokeLinecap="round" strokeLinejoin="round"></path> <path d="M45.7514 60H15.9209" strokeLinecap="round" strokeLinejoin="round"></path> <path d="M29.1411 54.4904H41.9556" strokeLinecap="round" strokeLinejoin="round"></path> <path d="M44.3905 54.4904H49.7422" strokeLinecap="round" strokeLinejoin="round"></path> <path d="M52.156 54.4904H57.5077" strokeLinecap="round" strokeLinejoin="round"></path> <path d="M52.1773 50.0758H57.529C57.7317 50.0758 57.8975 50.239 57.8975 50.4443V51.4947" strokeLinecap="round" strokeLinejoin="round"></path> <path d="M48.7524 60H64.2257C64.3468 60 64.46 59.9395 64.5337 59.8368C64.6021 59.7368 64.6153 59.6104 64.5732 59.4972L61.0642 50.3101" strokeLinecap="round" strokeLinejoin="round"></path> <path d="M14.0124 14.6462H27.543" strokeLinecap="round" strokeLinejoin="round"></path> <path d="M13.2438 60H6.368C6.24954 60 6.13634 59.9421 6.0679 59.8447C5.99946 59.7473 5.98103 59.6236 6.02052 59.5104L7.66314 54.7378C7.72895 54.5457 7.93954 54.443 8.13171 54.5088" strokeLinecap="round" strokeLinejoin="round"></path> </svg>
                                  </div>
                                </div>
                                <p>Use web camera</p>
                              </li>
                            </ul>
                          </div>
                        </div>
                       {/* )} */}
                      {this.state.webCam ?
                        <div className="truck__img">
                          <Camera
                            onTakePhoto={dataUri =>
                              this.onTakePhoto(dataUri, "plateImageUrl", "isCameraOn")
                            }
                            imageType={IMAGE_TYPES.PNG}
                            idealFacingMode={FACING_MODES.ENVIRONMENT}
                            isMaxResolution={true}
                            isImageMirror={false}
                            isSilentMode={false}
                            isDisplayStartCameraError={true}
                            isFullscreen={false}
                          />
                        </div> :
                        <button
                          className="manually__enter-btn"
                          onClick={() => {
                            const state = {
                              firstName: "",
                              lastName: "",
                              licenseNumber: "",
                              formdata: "",
                              state: "New York"
                            };
                            this.props.setInitialState({ state });
                          }}
                        >
                          {!loading && (
                            <>
                              <div className="circle__img">
                                <img src={license} alt="" />
                              </div>
                              <p> Manually enter license details</p>
                            </>
                          )}
                        </button>}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Spin>
        </div>
      </div>
    );
  }
}

export default NewDriver;
